import { SettingKey, SettingReadDTO, SettingType, SettingValue } from '../api/settings/setting.contracts';

// SettingArguments Interface
export interface SettingArguments {
  id: number;
  key: SettingKey;
  type: SettingType;
  value: SettingValue;
  createdAt: Date;
  updatedAt?: Date;
  deletedAt?: Date;
}

export enum SettingModelFieldNames {
  Id = 'id',
  Key = 'key',
  Type = 'type',
  Value = 'value',
  CreatedAt = 'createdAt',
  UpdatedAt = 'updatedAt',
  DeletedAt = 'deletedAt',
}

// Setting Class
export class SettingModel {
  id: number;
  key: SettingKey;
  type: SettingType;
  value: SettingValue;
  createdAt: Date;
  updatedAt?: Date;
  deletedAt?: Date;

  constructor(args: SettingArguments) {
    this.id = args.id;
    this.key = args.key;
    this.type = args.type;
    this.value = args.value;
    this.createdAt = args.createdAt;
    this.updatedAt = args.updatedAt;
    this.deletedAt = args.deletedAt;
  }

  toDTO(): SettingReadDTO {
    return {
      id: this.id,
      key: this.key,
      type: this.type,
      value: this.value,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt,
      deletedAt: this.deletedAt,
    };
  }

  static fromDTO(dto: SettingReadDTO): SettingModel {
    return new SettingModel({
      id: dto.id,
      key: dto.key,
      type: dto.type,
      value: dto.value,
      createdAt: dto.createdAt,
      updatedAt: dto.updatedAt,
      deletedAt: dto.deletedAt,
    });
  }
}
